export default {
  'chrome.png': 'chrome.png',
  'safari.png': 'safari.png',
  'samsung.png': 'samsung.png',
}
